import {makeActionCreator} from '../../redux-toolbelt';

export const setHasInitialScrollHappenedAction =
  makeActionCreator<'setHasInitialScrollHappened', boolean>('setHasInitialScrollHappened');
